import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.chemicals_index_page', () => {
  import('./internal/chemicals_index_page').then(({ default: Component }) => Component());
});
